/*
  <menu-drawer-panels> — root screen + one level of category panels inside the mobile drawer
  (snippets/header-drawer.liquid). Opening/closing the drawer itself stays with Trade's
  <header-drawer> (global.js).
*/
if (!customElements.get('menu-drawer-panels')) {
  class MenuDrawerPanels extends HTMLElement {
    connectedCallback() {
      this.root = this.querySelector('[data-drawer-root]');
      this.details = this.closest('details');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      this.querySelectorAll('[data-drawer-open]').forEach((button) => {
        button.addEventListener('click', () => this.open(button));
      });
      this.querySelectorAll('[data-drawer-back]').forEach((button) => {
        button.addEventListener('click', () => this.close());
      });

      // Escape closes the panel only. Trade's drawer closes on keyup, so swallow that keyup too.
      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape' || !this.current) return;
        this.closedWithEscape = true;
        this.close();
      });
      this.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !this.closedWithEscape) return;
        this.closedWithEscape = false;
        event.stopPropagation();
      });

      this.details?.addEventListener('toggle', () => {
        if (this.details.open) {
          requestAnimationFrame(() => this.updateDrawerHeight());
        } else {
          this.close(true);
        }
      });
    }

    open(button) {
      const panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!panel) return;

      this.current = panel;
      this.trigger = button;
      panel.hidden = false;
      panel.scrollTop = 0;

      requestAnimationFrame(() => {
        panel.classList.add('is-open');
        this.classList.add('panel-open');
      });

      button.setAttribute('aria-expanded', 'true');
      this.root.inert = true;
      panel.querySelector('[data-drawer-back]')?.focus({ preventScroll: true });
    }

    close(silent = false) {
      const panel = this.current;
      if (!panel) return;

      this.current = null;
      panel.classList.remove('is-open');
      this.classList.remove('panel-open');
      this.root.inert = false;
      this.trigger?.setAttribute('aria-expanded', 'false');

      const hide = () => (panel.hidden = true);
      if (silent || this.reducedMotion.matches) {
        hide();
      } else {
        panel.addEventListener('transitionend', hide, { once: true });
      }

      if (!silent) this.trigger?.focus({ preventScroll: true });
    }

    // The header hides its own search row while the drawer is open, so re-measure where it ends.
    updateDrawerHeight() {
      const header = document.querySelector('.section-header');
      if (!header) return;
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${Math.round(header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  customElements.define('menu-drawer-panels', MenuDrawerPanels);
}
